import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MarketingPageHeader from "@/components/MarketingPageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Smartphone, Layers, RefreshCw, WifiOff } from "lucide-react";
import { useTranslation } from "react-i18next";

const FlashcardsApp = () => {
  const { t } = useTranslation();

  const features = [
    { icon: Layers, title: t("apps.flashcards.features.tutorMade.title"), description: t("apps.flashcards.features.tutorMade.description") },
    { icon: RefreshCw, title: t("apps.flashcards.features.spacedRepetition.title"), description: t("apps.flashcards.features.spacedRepetition.description") },
    { icon: WifiOff, title: t("apps.flashcards.features.offline.title"), description: t("apps.flashcards.features.offline.description") },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <MarketingPageHeader
        containerClassName="max-w-5xl"
        eyebrow={
          <div className="inline-flex items-center gap-2 rounded-full bg-primary/15 px-3 py-1 text-xs font-medium text-foreground">
            <Smartphone className="w-3.5 h-3.5" />
            {t("apps.comingSoon")}
          </div>
        }
        title={t("footer.links.appFlashcards")}
        subtitle={t("apps.flashcards.subtitle")}
      />
      <main className="container mx-auto px-4 pb-24 pt-6 max-w-5xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {features.map((feature) => (
            <Card key={feature.title} className="bg-secondary/50">
              <CardContent className="p-6">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-3">
                  <feature.icon className="w-5 h-5 text-foreground" />
                </div>
                <h3 className="font-semibold text-foreground mb-1">{feature.title}</h3>
                <p className="text-sm text-muted-foreground">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default FlashcardsApp;
